import { render } from "./Whatsapp.vue?vue&type=template&id=1c49a82e&scoped=true&async=true"
import script from "./Whatsapp.vue?vue&type=script&async=true&lang=js"
export * from "./Whatsapp.vue?vue&type=script&async=true&lang=js"

import "./Whatsapp.vue?vue&type=style&index=0&id=1c49a82e&async=true&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c49a82e"]])

export default __exports__